<script setup>
const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  flowType: {
    type: String,
    default: '',
  },
  active: {
    type: Boolean,
    default: true,
  },
  createdAt: {
    type: Number,
    default: null,
  },
});

const emit = defineEmits(['click']);

const handleClick = () => {
  emit('click', props.id);
};
</script>

<template>
  <div
    class="relative flex items-start gap-4 p-4 transition-colors border rounded-lg cursor-pointer bg-n-solid-2 border-n-weak hover:border-n-strong hover:bg-n-solid-3"
    @click="handleClick"
  >
    <div class="flex-1 min-w-0">
      <div class="flex items-start justify-between gap-2 mb-2">
        <h3 class="text-base font-semibold text-n-slate-12">
          {{ name }}
        </h3>
        <span
          class="px-2 py-0.5 text-xs font-medium rounded-full"
          :class="[
            active
              ? 'bg-green-500/10 text-green-600 dark:bg-green-500/20 dark:text-green-400'
              : 'bg-n-slate-3 text-n-slate-10',
          ]"
        >
          {{ active ? $t('AI_VOICE.ACTIVE') : $t('AI_VOICE.INACTIVE') }}
        </span>
      </div>

      <p v-if="description" class="mb-3 text-sm text-n-slate-11">
        {{ description }}
      </p>

      <div
        v-if="flowType"
        class="flex items-center gap-2 text-xs text-n-slate-10"
      >
        <span class="flex items-center gap-1">
          <i class="w-3.5 h-3.5 i-lucide-git-branch" />
          {{ flowType }}
        </span>
      </div>
    </div>

    <div class="flex items-center">
      <i class="w-5 h-5 text-n-slate-10 i-lucide-chevron-right" />
    </div>
  </div>
</template>
